<template>
    <div>
        <div class="top-Lv1">
            <span class="tittle-lv1">添加成员</span>
        </div>
        <div class="mainContent">
            <div class="mainNav">
                <Button type="primary" size="small" @click="handleSubmit('formValidates')">保存</Button>
                <Button type="ghost" size="small" @click="$router.go(-1)">取消</Button>
            </div>
            <div class="froms">
                <Form ref="formValidates" :model="formValidate" :rules="ruleValidate" :label-width="110">
                    <Row class="rows">
                        <Col span="16">
                        <FormItem label="姓名 :" prop="fullname">
                            <Input size="small" width="60" v-model="formValidate.fullname" placeholder="请填写名字"></Input>
                        </FormItem>
                        <FormItem label="性别 :" prop="sex">
                            <RadioGroup v-model="formValidate.sex">
                                <Radio label="1">男</Radio>
                                <Radio label="2">女</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="密码 :" prop="password">
                            <Input size="small" type="password" v-model="formValidate.password" placeholder="请填写6-12位字母、数字或下划线组成的密码"></Input>
                        </FormItem>
                        <FormItem label="确认密码 :" prop="password2">
                            <Input size="small" type="password" v-model="formValidate.password2"
                                   placeholder="请填写6-12位字母、数字或下划线组成的密码"></Input>
                        </FormItem>
                        <FormItem label="手机 :" prop="mobile">
                            <Input size="small" v-model="formValidate.mobile" placeholder="成员通过验证该手机后可加入企业"></Input>
                        </FormItem>
                        </Col>
                        <Col span="16">
                        <FormItem label="座机 :">
                            <Input size="small" v-model="formValidate.tel" placeholder="请输入成员的座机号码"></Input>
                        </FormItem>
                        <FormItem label="邮箱 :">
                            <Input size="small" v-model="formValidate.email" placeholder="请输入成员的邮箱"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row v-if="depShow" class="rows">
                            <Col span="16">
                            <FormItem label="部门 :" prop="department">
                                <Cascader :data="data1" v-model="formValidate.department"  change-on-select class="iv-downs"></Cascader>
                            </FormItem>
                            </Col>
                            <Col span="4" v-if="addShow">
                            <div class="selectEnd" v-hasPermission="'web_member_department'" @click="handleRender">添加部门</div>
                            </Col>
                            <Col span="16">
                            <FormItem label="是否为主管 :" prop="single">
                                <RadioGroup v-model="formValidate.single">
                                    <Radio label="1">主管</Radio>
                                    <Radio label="2">专员</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem label="职务 :" prop="duty">
                                <Input v-model="formValidate.duty" placeholder="请输入职务名称"></Input>
                            </FormItem>
                            </Col>
                            <Col span="16" v-if="moreShow" style="border-top: 1px dotted #dddee1;">
                            <FormItem style="color: #3399ff;cursor:pointer;">
                                <div  @click="addDuty">
                                    <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                                </div>
                            </FormItem>
                            </Col>
                        </Row>
                    <!--部门1-->
                    <Row class="rows" v-if="depShow1">
                        <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep1">
                            <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                            删除
                        </div>
                        <Col span="16">
                        <FormItem label="部门1 :">
                            <Cascader :data="data1" v-model="formValidate.department1"  change-on-select class="iv-downs"></Cascader>
                        </FormItem>
                        </Col>
                        <Col span="4" v-if="addShow">
                        <div class="selectEnd" @click="handleRender">添加部门</div>
                        </Col>
                        <Col span="16">
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single1">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务1 :">
                            <Input v-model="formValidate.duty1" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        </Col>
                        <Col span="16" v-if="moreShow1" style="border-top: 1px dotted #dddee1;">
                        <FormItem style="color: #3399ff;cursor:pointer;">
                            <div  @click="addDuty1">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
                        <!--部门2-->
                    <Row class="rows" v-if="depShow2">
                    <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep2">
                        <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                        删除
                    </div>
                    <Col span="16">
                        <FormItem label="部门2 :">
                            <Cascader :data="data1" v-model="formValidate.department2"  change-on-select class="iv-downs"></Cascader>
                        </FormItem>
                        </Col>
                        <Col span="4" v-if="addShow">
                        <div class="selectEnd" @click="handleRender">添加部门</div>
                        </Col>
                        <Col span="16">
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single2">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务2 :">
                            <Input v-model="formValidate.duty2" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        </Col>
                        <Col span="16" v-if="moreShow2">
                        <FormItem style="color: #3399ff;cursor:pointer;">
                            <div  @click="addDuty2">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
                        <!--部门3-->
                    <Row class="rows" v-if="depShow3">
                        <div style="position: absolute;right: 10px;color: #ed3f14;cursor:pointer;" @click="delDep3">
                            <!--<Icon style="font-size: 24px;cursor:pointer;" type="ios-close-outline"></Icon>-->
                            删除
                        </div>
                    <Col span="16">
                        <FormItem label="部门3 :">
                            <Cascader :data="data1" v-model="formValidate.department3"  change-on-select class="iv-downs"></Cascader>
                        </FormItem>
                        </Col>
                        <Col span="4" v-if="addShow">
                        <div class="selectEnd" @click="handleRender">添加部门</div>
                        </Col>
                        <Col span="16">
                        <FormItem label="是否为主管 :">
                            <RadioGroup v-model="formValidate.single3">
                                <Radio label="1">主管</Radio>
                                <Radio label="2">专员</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="职务3 :">
                            <Input v-model="formValidate.duty3" placeholder="请输入职务名称"></Input>
                        </FormItem>
                        </Col>
                        <!--<parent :childrens="childrens"></parent>-->
                        <Col span="16" v-if="moreShow3">
                        <FormItem style="color: #3399ff;cursor:pointer;">
                            <div  @click="addDuty3">
                                <Icon type="plus-circled" style="font-size: 15px;"></Icon><div style="display:inline-block;margin-left: 10px">更多职务</div>
                            </div>                        </FormItem>
                        </Col>
                    </Row>
<!--===================================================================================================================-->
                    <Row class="rows">
                        <Col span="16">
                        <FormItem label="权限组 :" prop="roles">
                            <Select v-model="formValidate.roles" style="width: 348px">
                                <Option v-for="(item,key) in rolesArr" :value="item.id" :key="key">{{item.alias}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="4" v-if="roleShow">
                        <div class="selectEnd" v-hasPermission="'web_permission_add'" style="margin-top: 8px" @click="modal7 = true">添加权限组</div>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div class="mainNav">
                <Button type="primary" size="small" @click="handleSubmit('formValidates')">保存</Button>
                <Button type="ghost" size="small" @click="$router.go(-1)">取消</Button>
            </div>
        </div>
        <!--新建部门-->
        <Modal
            v-model="loading"
            title="新建部门"
            @on-ok="formSubmit">
            <Form :model="formItem" :label-width="80">
                <FormItem label="上级部门">
                    <Select v-model="model2">
                        <Option v-for="item in formItem.select" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="新建部门">
                    <Input v-model="formItem.input"  placeholder="新建部门名称"></Input>
                </FormItem>
                <FormItem label="部门属性">
                    <Select v-model="model4">
                        <Option v-for="item in formItem.attribute" :value="item.id" :key="item.id">{{ item.attribute }}</Option>
                        <Option :value="-1">自定义</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Input v-model="formItem.custom" v-if="custom"  placeholder="自定义部门属性"></Input>
                </FormItem>
            </Form>
        </Modal>
        <!--新建权限组-->
        <Modal
            title="新增权限组"
            v-model="modal7"
            :closable="false"
            @on-ok="roleSubmit"
            ok-text="保存"
            :width="800">
            <div class="mainContent">
                <div class="froms">
                    <Form ref="formValidate" :model="formValidate" label-position="left" :rules="ruleValidate" :label-width="90">
                        <Row>
                            <Col span="16">
                            <FormItem :label-width="120" label="权限组名称 :" prop="rolesName">
                                <Input size="small" v-model="formValidate.rolesName" placeholder="成员通过验证该手机后可加入企业"></Input>
                            </FormItem>
                            <FormItem :label-width="120" label="权限组英文名称 :" prop="rolesName">
                                <Input size="small" v-model="formValidate.alias" placeholder="成员通过验证该手机后可加入企业"></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Tabs value="name1">
                            <TabPane label="应用端权限" name="name1">
                                <Scroll style="margin-top: -25px" height="450">
                                    <div v-for="(item,key) in itemList" :key="key">
                                        <div class="mainNav" style="background-color: #f8f8f9;border: 0;line-height: 24px;font-weight: bold">{{item.title}} <div class="iv-icon-down" @click="showPermiss(item.id)"><Icon v-if="item.access" type="chevron-down"></Icon><Icon v-if="!item.access" type="chevron-right"></Icon></div>
                                        </div>
                                        <div v-for="(items,key1) in item.children" :key="key1" :class="item.access ? 'showCheck' :  'hideCheck'">
                                            <div style="padding-top:6px;margin-top:6px;margin-left: 20px;">
                                                <Checkbox
                                                    :indeterminate="auths[items.id].indeterminate"
                                                    :value="auths[items.id].checkAll"
                                                    @click.prevent.native="handleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                                            </div>
                                            <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items !== item.children[item.children.length -1]" style="border-bottom: 1px dashed #e9e9e9;">
                                                <Checkbox style="font-weight: 100;margin-left: 20px;"  v-for="(res,key2) in items.children" :key="key2" :label="res.title"></Checkbox>
                                            </CheckboxGroup>
                                            <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items === item.children[item.children.length -1]">
                                                <Checkbox style="font-weight: 100;margin-left: 20px;"  v-for="(res,key3) in items.children" :key="key3" :label="res.title"></Checkbox>
                                            </CheckboxGroup>
                                        </div>
                                    </div>
                                </Scroll>
                            </TabPane>
                            <TabPane label="APP端权限" name="name2">
                                <Scroll style="margin-top: -25px" height="450">
                                    <!--<p class="topName">{{$store.getters.comInfo.contact}} <span>超级管理员</span></p>-->
                                    <Form :model="formItem">
                                        <FormItem>
                                            <div style="font-size: 24px;font-weight: bold;text-align: center;height: 405px;line-height: 200px">我是CRM权限，暂时不设置任何权限</div>
                                        </FormItem>
                                    </Form>
                                    <!--<Checkbox style="margin-top: 5px" v-model="single">全部选择</Checkbox>-->
                                    <!--<Button v-if="button==='个人权限' && permissionUpdate" style="float: right" @click="confirmUpdate(2)" type="primary">确认修改</Button>-->
                                    <!--<Button v-if="button==='权限组' && permissionRoles" style="float: right" @click="confirmRoles(2)" type="primary">确认修改</Button>-->
                                </Scroll>
                            </TabPane>
                            <TabPane label="WEB端权限" name="name3">
                                <Form :model="formItem">
                                    <Scroll height="450" style="margin-top: -25px;border-bottom: 1px solid #dddee1">
                                        <FormItem>
                                            <div v-for="(items,key) in webList" :key="key">
                                                <div style="padding-top:6px;margin-top:6px;">
                                                    <Checkbox
                                                        :indeterminate="webAuths[items.id].indeterminate"
                                                        :value="webAuths[items.id].checkAll"
                                                        @click.prevent.native="webhandleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                                                </div>
                                                <CheckboxGroup v-model="formItem.checkbox" style="border-bottom: 1px solid #e9e9e9;" @on-change="webcheckAllGroupChange">
                                                    <Checkbox style="font-weight: 100;"  v-for="(res,key1) in items.children" :key="key1" :label="res.title"></Checkbox>
                                                </CheckboxGroup>
                                            </div>
                                        </FormItem>
                                    </Scroll>
                                </Form>
                            </TabPane>
                        </Tabs>
                    </Form>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import ruleValidate from '../../validator'
    export default {
        name: 'memberAdd',
        data() {
            return {
                moreShow3:false,
                moreShow2:false,
                moreShow1:false,
                moreShow:true,
                depShow:true,
                depShow1:false,
                depShow2:false,
                depShow3:false,
                theme1: 'light',
                memberList: [],
                webList: [],
                curMember:'',
                indeterminate: true,
                checkAll: false,
                arr: [],
                model4: 0,
                spinShow: true,
                itemList:[],
                auth: [],
                auths: [],
                dutyArr: [],
                addShow: true,
                roleShow: true,
                attr:'1',
                value1: [1,2,3],
                modal1: false,
                modal7: false,
                modal8: false,
                dutyShow:false,
                data: [],
                data1:[],
                custom: false,
                result: [],
                model2: 0,
                formItem:{
                    input: '',
                    select: {},
                    roles:[],
                    checkbox:[],
                    post:''
                },
                loading: false,
                rolesArr: [],
                departmentList:[],
                formValidate: {
                    fullname: '',
                    password: '',
                    password2: '',
                    sex: '',
                    mobile: '',
                    tel: '',
                    email: '',
                    department: [],
                    duty: '',
                    single:'2',
                    department1: [],
                    duty1: '',
                    single1:'2',
                    department2: [],
                    duty2: '',
                    single2:'2',
                    department3: [],
                    duty3: '',
                    single3:'2',
                    roles:'',
                    rolesName:'',
                    alias:'',
                }
            }
        },
        computed:{
            ruleValidate:function () {
                return ruleValidate
            }
        },
        mounted() {
            this.$store.dispatch('setPage', '4');
            this.getDepartmen();
            this.getAuth();
            this.roles();
        },
        methods: {
            toAdd() {
                this.$router.push('memberAdd')
            },

            //获取角色列表
            roles(){
                this.$http.get(this.$api.ROLES + "?com_id=" + this.$store.getters.userInfo.com_id,{
                }).then(res => {
                    if(res.data.status == 1){
//                        this.formValidate.roles = this.formValidate.roles ? this.formValidate.roles : res.data.data[0].id;
                        this.rolesArr =  res.data.data;
                    }else{
                        this.$Message.error('网络错误');
                    }
                }, err => {
                    this.$Message.error('网络错误');
                })
            },

            //获取部门信息
            getDepartmen(){
                this.$http.post(this.$api.DEPARTMENT_LIST,{
                    com_id:sessionStorage.getItem('com_id')
                }).then(res => {
                    this.departmentList = [];
                    this.data1 =  res.data.data;
                    this.result =  res.data.result;
                    this.departments();
                    let data = res.data.result;
                    this.formItem.select = data;
                    this.formItem.attribute = res.data.attribute;
                    this.model3 = this.formItem.attribute[0].id;
                    res.data.data.map(item=>{
                        if(item.pid == 0){
                            this.model2 = item.value;
                        }
                        let obj = {};
                        if(item.children.length > 0) {
                            obj.title = item.label;
                            obj.expand = true;
                            obj.children = this.departmentData(item.children);
                        }else{
                            obj.title = item.label;
                        }
                        this.departmentList.push(obj);
                        this.model2 = this.formItem.select[0].value;
                    });
                }, err => {
                    this.$api.errcallback(err)
                });
            },

            //处理部门数据
            departmentData(data){
                let vm = this
                let arr = [];
                data.map(item=>{
                    let obj = {};
                    if(item.children.length > 0){
                        obj.title= item.label;
                        obj.expand= true;
                        obj.children = vm.departmentData(item.children);
                    }else{
                        obj.title= item.label;
                    }
                    arr.push(obj);
                })
                return arr;
            },

            // 新增部门弹框
            handleRender(){
                this.loading = true;
            },

            //添加成员
            handleSubmit(name) {
                var arr = [];
                var result = {};
                result.director = this.formValidate.single;
                result.duty = this.formValidate.duty;
                result.dep = this.formValidate.department[this.formValidate.department.length - 1];
                arr.push(result);
                if(this.formValidate.department1.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department1[this.formValidate.department1.length - 1];
                    result.duty = this.formValidate.duty1;
                    result.director = this.formValidate.single1;
                    arr.push(result);
                }
                if(this.formValidate.department2.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department2[this.formValidate.department2.length - 1];
                    result.duty = this.formValidate.duty2;
                    result.director = this.formValidate.single2;
                    arr.push(result);
                }
                if(this.formValidate.department3.length > 0){
                    var result = {};
                    result.dep = this.formValidate.department3[this.formValidate.department3.length - 1];
                    result.duty = this.formValidate.duty3;
                    result.director = this.formValidate.single3;
                    arr.push(result);
                }

                var data = {
                    com_id:this.$store.getters.userInfo.com_id,
                    fullname: this.formValidate.fullname,
                    password: this.formValidate.password,
                    password2: this.formValidate.password2,
                    sex: this.formValidate.sex,
                    mobile: this.formValidate.mobile,
                    tel: this.formValidate.tel,
                    email: this.formValidate.email,
                    uid:this.$store.getters.userInfo.id,
                    department: arr,
//                    admin: this.formValidate.admins,
//                    department: this.formValidate.department[this.formValidate.department.length - 1],
//                    duty: this.formValidate.duty,
                    roles: this.formValidate.roles,
//                    director: director,
                };
                this.addShow = false;
                this.roleShow = false;
                this.$refs[name].validate((valid) => {
                    if (valid) {
//                        if(this.formValidate.department.length <= 0){
//                            this.$Message.error('请选择成员所属部门');
//                            return false;
//                        }
                        this.$Spin.show();
                        this.$http.post(this.$api.ADD_USER, data).then(res => {
                            this.$Spin.hide();
                            if (res.data.status === '1') {
                                this.$Message.info(res.data.msg);
                                this.$router.go(-1)
                            }else{
                                this.$Message.info(res.data.msg);
                            }
                        }, err => {
                            this.$Message.error('网络错误');
                            this.$router.go(-1)
                        });
                    } else {
                        this.$Message.error('请您检查重要信息是否填写完成!');
                    }
                })


            },

            //查找部门路径
            departmentDatas(id){
                for(var i=0; i<this.result.length; i++)
                {
                    if(id === this.result[i].value){
                        this.formValidate.department.unshift(this.result[i].value);
                        if(this.result[i].pid != 0){
                            this.departmentDatas(this.result[i].pid);
                        }
                    }
                }
            },

            //处理部门数据信息
            departments(){
                if(this.result.length > 0){
                    this.formValidate.department = [];
                    for(var j=0; j< this.result.length; j++){
                        if(this.result[j].value == this.value1){
                            this.formValidate.department.unshift(this.result[j].value);
                            this.departmentDatas(this.result[j].pid);
                        };
                    }
                }
            },

            //权限列表
            getAuth() {
                this.$http.get(this.$api.GET_AUTH).then(res => {
                    this.itemList = res.data.data;
                    this.webList = res.data.web;
                    this.pcLists();
                    this.webLists();
                }, err => {
                    this.$Message.error('网络错误');
                });
            },

            //处理pc权限数据
            pcLists() {
                let auth = [];
                let auths = [];
                if(this.itemList.length > 0)
                    this.itemList.forEach(item=>{
                        auth.push(item.title);
                        if(item.children.length > 0){
                            item.children.forEach(items=>{
                                let arr = [];
                                let result = [];
                                if(items.children.length > 0){
                                    items.children.forEach(res=>{
                                        arr.push(res.title);
                                    })
                                }
                                result.name = arr;
                                result.indeterminate = false;
                                result.checkAll = false;
                                auths[items.id] = result;
                            })
                        }
                    });
                this.auth = auth;
                this.auths = auths;
            },

            //处理web权限数据
            webLists(){
                let auth = [];
                let auths = [];
                if(this.webList.length > 0)
                    this.webList.forEach(item=>{
                        auth.push(item.title);
                        let arr = [];
                        let result = {};
                        if(item.children.length > 0){
                            item.children.forEach(items=>{
                                arr.push(items.title);
                            })
                        }

                        result.name = arr;
                        result.indeterminate = false;
                        result.checkAll = false;
                        auths[item.id] = result;
                    });
                this.webAuth = auth;
                this.webAuths = auths;
            },

            //全部选择
            handleCheckAll (val) {
                if(this.auths[val].indeterminate){
                    this.auths[val].checkAll = true;
                }else{
                    this.auths[val].checkAll = !this.auths[val].checkAll;
                }
                this.auths[val].indeterminate = false;
                if (this.auths[val].checkAll) {
                    if(this.formItem.checkbox.length === 0){
                        this.formItem.checkbox = this.auths[val].name;
                    }else{
                        this.formItem.checkbox.forEach(item=>{
                            this.auths[val].name.map(items=>{
                                if(item === items){
                                    let index = this.formItem.checkbox.indexOf(item);
                                    this.formItem.checkbox.splice(index,1);
                                }
                            })
                        })
                        this.formItem.checkbox = this.formItem.checkbox.concat( this.auths[val].name);
                    }
                }else {
                    if (this.formItem.checkbox === this.auths[val].name) {
                        this.formItem.checkbox = [];
                    } else {
                        for(var i=0; i<=this.formItem.checkbox.length; i++){
                            this.auths[val].name.forEach(items => {
                                if (this.formItem.checkbox[i] === items) {
                                    this.formItem.checkbox.splice(i,1);
                                }
                                this.itemList.map(item=>{
                                    if(item.children.length > 0){
                                        item.children.map(val=>{
                                            if(val.children.length > 0){
                                                val.children.map(value=>{
                                                    if(value.title === items){
                                                        if(this.formItem.checkbox.indexOf(val.title) > 0){
                                                            this.formItem.checkbox.splice(this.formItem.checkbox.indexOf(val.title),1);
                                                        }
                                                    }
                                                })
                                            }

                                        })
                                    }
                                })
                            })
                        }
                    }
                }
            },

            //单独选择
            checkAllGroupChange (data) {
                let permission = [];
                this.itemList.map(item=>{
                    item.children.map(items=>{
                        if(items.children.length>0){
                            let arr = [];
                            items.children.map(res=>{
                                if(data.indexOf(res.title)>= 0){
                                    permission.push(res.name);
                                    arr.push(true);
                                }else{
                                    arr.push(false);
                                }
                            })

                            if(arr.indexOf(false)>= 0 && arr.indexOf(true)>= 0){
                                //不全选
                                this.auths[items.id].indeterminate = true;
                                this.auths[items.id].checkAll = false;
                            }else if(arr.indexOf(false) < 0){
                                //全选
                                this.auths[items.id].indeterminate = false;
                                this.auths[items.id].checkAll = true;
                            }
                            if(this.auths[items.id].indeterminate || this.auths[items.id].checkAll){
                                permission.push(items.name);
                                permission.push(item.name);
                            }
                        }
                    })

                })
//                this.arr = permission;
                this.arr = this.arr.concat(permission);
            },

            //web全部选择
            webhandleCheckAll (val) {
                if(this.webAuths[val].indeterminate){
                    this.webAuths[val].checkAll = false;
                }else{
                    this.webAuths[val].checkAll = !this.webAuths[val].checkAll;
                }
                this.webAuths[val].indeterminate = false;
                if (this.webAuths[val].checkAll) {
                    if(this.formItem.checkbox.length === 0){
                        this.formItem.checkbox = this.webAuths[val].name;
                    }else{
                        this.formItem.checkbox.forEach(item=>{
                            this.webAuths[val].name.map(items=>{
                                if(item === items){
                                    let index = this.formItem.checkbox.indexOf(item);
                                    this.formItem.checkbox.splice(index,1);
                                }
                            })
                        })
                        this.formItem.checkbox = this.formItem.checkbox.concat( this.webAuths[val].name);
                    }
                }else {
                    if (this.formItem.checkbox === this.webAuths[val].name) {
                        this.formItem.checkbox = [];
                    } else {
                        for(var i=0; i<=this.formItem.checkbox.length; i++){
                            this.webAuths[val].name.forEach(items => {
                                if (this.formItem.checkbox[i] === items) {
                                    this.formItem.checkbox.splice(i,1);
                                }
                            })
                        }
                    }
                }
            },

            //web单独选择
            webcheckAllGroupChange (data) {
                let permission = [];
                this.webList.map(item=>{
                    let arr = [];
                    item.children.map(items=>{
                        if(data.indexOf(items.title)>= 0){
                            permission.push(items.name);
                            arr.push(true);
                        }else{
                            arr.push(false);
                        }
                    })
                    if(arr.indexOf(false)>= 0 && arr.indexOf(true)>= 0){
                        this.webAuths[item.id].indeterminate = true;
                        this.webAuths[item.id].checkAll = false;
                        permission.push(item.name);
                    }else if(arr.indexOf(false) < 0){
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = true;
                        permission.push(item.name);
                    }else{
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = false;
                    }
                })
                this.arr = this.arr.concat(permission);
            },

            //添加组权限
            roleSubmit() {
                this.checkAllGroupChange(this.formItem.checkbox);
                let data = [...new Set(this.arr)];
                this.$http.post(this.$api.ROLES, {
                    gurad_name: 'web',
                    alias: this.formValidate.alias,
                    name: this.formValidate.rolesName,
                    data: data,
                    uid:this.$store.getters.userInfo.id,
                    com_id: this.$store.getters.userInfo.com_id,
                }).then(res => {
                    console.log('更改权限', res.data.data);
                    if(res.data.status == 1){
                        this.formValidate.roles = res.data.data;
                        this.roles();
                        this.modal7 = false;
                        this.$Message.info('修改权限成功');
                    }else{
                        this.$Message.info('修改权限失败');
                    }
                }, err => {
                    this.$Message.error('网络错误');
                });
            },

            //添加子部门
            formSubmit(){
                this.$http.post(this.$api.DEPARTMENT,{
                    'pid' : this.model2,
                    'depName' : this.formItem.input,
                    'com_id': this.$store.getters.userInfo.com_id,
                    'custom': this.formItem.custom,
                    'attr':this.model4,
                }).then(res => {
                    if(res.data.status == 1){
                        this.$Message.info(res.data.msg);
                        this.formItem.input = '';
                        this.model2 = 0;
                        this.formValidate.department = res.data.data;
                        this.value1 = res.data.data;
                        this.$Modal.remove();
                        this.getDepartmen();
                    }else{
                        this.$Message.error (res.data.msg);
                        this.loading = true;
                    }
                }, err => {
                    this.$Message.error ('网络错误');
                });

            },

            //添加更多职务
            addDuty(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = true;
            },

            //添加更多职务
            addDuty1(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = false;
                this.depShow2 = true;
                this.moreShow2 = true;
            },

            //添加更多职务
            addDuty2(){
                this.depShow = true;
                this.moreShow = false;
                this.depShow1 = true;
                this.moreShow1 = false;
                this.depShow2 = true;
                this.moreShow2 = false;
                this.depShow3 = true;
                this.moreShow3 = false;
            },

            //删除新增模板
            delDep1(){
                this.depShow1 = false;
                this.moreShow1 = false;
                this.formValidate.department1 = [];
                if(this.depShow2 && !this.depShow3){
                    this.moreShow2 = true;
                }else if(!this.depShow2 && !this.depShow3){
                    this.moreShow = true;
                }
            },

            //删除新增模板
            delDep2(){
                this.depShow2 = false;
                this.moreShow2 = false;
                this.formValidate.department2 = [];
                if(this.depShow1 && !this.depShow3){
                    this.moreShow1 = true;
                }else if(!this.depShow1 && !this.depShow3){
                    this.moreShow = true;
                }
            },

            //删除新增模板
            delDep3(){
                this.depShow3 = false;
                this.moreShow3 = false;
                this.formValidate.department3 = [];
                if(this.depShow1 && !this.depShow1){
                    this.moreShow1 = true;
                }else if(this.depShow1 && this.depShow2){
                    this.moreShow2 = true;
                }else if(!this.depShow1 && !this.depShow2){
                    this.moreShow = true;
                }
            },

            //是否显示按钮权限
            showPermiss(val){
                this.checkId = val;
                this.itemList.forEach(item=>{
                    if(item.id === val){
                        item.access = !item.access;
                    }
                })
            },
        },
        watch:{
            'formValidate.department':function(val){
                console.log(val);
                this.addShow = true;
                if(val.length == 1){
                    this.custom = true;
                }else{
                    this.custom = false;
                }
            },
            'model4':function(val){
                if(val === -1){
                    this.custom = true;
                }else{
                    this.custom = false;
                }
            },
            'formValidate.duty':function (val){
                //是否为主管
                if(val){
                    this.dutyShow = true;
                }else{
                    this.dutyShow = false;
                }
            } ,
            'formValidate.roles':function (val) {
                console.log(val);
                this.roleShow = true;
            },
        }

    }
</script>

<style scoped>
    .iv-downs .ivu-cascader-arrow {
        right:164px;
    }
    .selectEnd {
        margin-left: -150px;
        margin-top: 4px;
        color: #3399ff;
        cursor:pointer;
    }
    .mainNav button {
        background-color: #fff;
    }

    .mainNav button:first-child {
        background-color: #2d8cf0;
    }

    .mainNav .adds:hover {
        opacity: 0.8;
    }

    .froms {
        margin-left: 100px;
        padding: 8px 13px;
    }

    .photos {
        position: absolute;
        top: 6px;
        left: 0;
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 30px;
        font-size: 40px;
    }

    .rows {
        padding: 20px 0;
        border-bottom: 1px solid #E4E6E9;
    }

    .ivu-form-item {
        margin-bottom: 2px;
    }
    .iv-icon-down {
        float: right;
        margin-top: 1px;
        margin-right: -15px;
        cursor: pointer;
        display: inline;
        width: 40px;
        height: 28px;
    }

    .modelBox {
        padding: 4px 14px;
    }

    .memberList {
        height: 367px;
        margin-top: 20px;
    }

    .memberList li {
        height: 28px;
        padding-left: 28px;
        line-height: 28px;
    }

    .memberList li i {
        font-size: 16px;
        line-height: 27px;
        vertical-align: top;
    }

    .memberList li i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .memberList li i:last-of-type {
        margin-left: 10px;
        color: #ccc;
        font-size: 12px;
    }

    .xuanZe {
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid #E4E6E9;
        height: 407px;
    }

    .xuanZe span {
        display: block;
        font-size: 14px;
        color: #787878;
        margin-bottom: 10px;
    }

    .menberType {
        border: 1px solid #E4E6E9;
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
    }

    .menberType i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .menberType i:last-child {
        margin-left: 20px;
        color: #ccc;
    }
    .hideCheck {
        display: none;
    }
    .showCheck {
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/member/memberAdd.vue